<script lang="ts" module>
	export const symbolId = "ishavskraft-icon-grid";
	export const symbol = `
		<symbol id="${symbolId}" viewBox="0 0 24 24">
	  <path
    d="M6.75 4.75L7.15 6.964C7.216 7.398 7.176 7.839 7.031 8.26L2.75 20.75M12.75 4.75L12.35 6.964C12.284 7.398 12.324 7.839 12.469 8.26L16.75 20.75"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M0.75 9.75L1.074 8.67C1.161 8.38 1.204 8.235 1.303 8.113C1.401 7.992 1.547 7.903 1.838 7.727L6.224 5.07C6.484 4.912 6.615 4.833 6.766 4.792C6.916 4.75 7.078 4.75 7.4 4.75H12.1C12.422 4.75 12.583 4.75 12.734 4.79C12.884 4.832 13.015 4.91 13.276 5.069L17.662 7.727C17.953 7.903 18.099 7.992 18.197 8.113C18.295 8.235 18.339 8.38 18.427 8.671L18.75 9.75M0.75 20.75H18.75M1.75 7.75H17.25"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M7.25 8.75L13.75 13.25L2.75 20.75"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M12.25 8.75L5.75 13.25L16.75 20.75M6.75 4.75L8.15 2.51C8.883 1.337 9.25 0.75 9.75 0.75C10.25 0.75 10.617 1.337 11.35 2.51L12.75 4.75"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
		</symbol>`;
</script>

<script lang="ts">
	import type { ClassValue } from "svelte/elements";

	let {
		class: classes = null,
		ariaHidden = true,
	}: {
		class?: ClassValue | null;
		ariaHidden?: boolean;
	} = $props();
</script>

<svg
	aria-hidden={ariaHidden}
	width="24"
	height="24"
	viewBox="0 0 24 24"
	xmlns="http://www.w3.org/2000/svg"
	class={classes}
	fill="none"
>
	<use href="#{symbolId}" />
</svg>
